import { Typography, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./dashboard.module.scss";
import {
  faCircleInfo,
  faArrowTrendUp,
  faArrowTrendDown
} from "@fortawesome/free-solid-svg-icons";
import { FileTimeIcon } from "../../assets/icons/FileTimeIcon";

const { Text } = Typography;

const TotalItems: React.FC<any> = ({ dashboardData, filters }) => {
  const itemTotal = dashboardData?.totalItemsOrdered?.value ?? 0;
  const previous = dashboardData?.totalItemsOrdered?.previousPeriod ?? 0;
  const percentageChange = previous !== 0 
      ? ((itemTotal - previous) / previous) * 100
      : 0;
  const isIncrease = percentageChange >= 0;
  var isNotCustom = false;
  if(filters?.[1])
  {
    isNotCustom = true;
  }
  
  return (
    <div className={styles.cardHeader}>
      <Text
        type="secondary"
        strong
        className={styles.cardText}
      >
        <span className={styles.cardTextIcon}>
          <span className={styles.leadsMetricIconWrap}><FileTimeIcon /></span>
          TOTAL # OF ITEMS ORDERED
        </span>
      </Text>

      <div className={styles.cardBody}>
        <Text className={styles.cardVal}>
          {itemTotal.toLocaleString()}
        </Text>

        {isNotCustom && previous > 0 && (
          <Text 
            className={styles.cardFont}
            style={{ color: isIncrease ? "#16D761" : "#f3083b" }}
          >
            <FontAwesomeIcon
              icon={isIncrease ? faArrowTrendUp : faArrowTrendDown}
              style={{ marginRight: 4 }}
            />
            {(percentageChange < 0 ? "-" : "") + Math.abs(percentageChange).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}%
          </Text>
          )
        }
      </div>

      {isNotCustom && previous > 0 && (
        <Text type="secondary" className={styles.cardFooter}>
          {previous.toLocaleString()} Ordered Last Period
          <Tooltip title="Orders from the previous reporting period">
            <FontAwesomeIcon
              icon={faCircleInfo}
              className={`${styles.cardIcon} ${styles.cardIconMargin}`}
            />
          </Tooltip>
        </Text>
        )
      }
    </div>
  );
};

export default TotalItems;
